import Cookies from "js-cookie";

export const checkUserTabAccess = (tabAccessKey) => {
   const cookieValue =
      Cookies.get("loginToken") && JSON.parse(Cookies.get("loginToken"));
   const tabAccess = cookieValue?.userDetails?.tabAccess;
   
   return tabAccess? tabAccess.find(tab => tab.tabName.toLowerCase() === tabAccessKey.toLowerCase()): null;
};
